import { g as e } from "./index767.mjs";
import { i } from "./index761.mjs";
var l = e, r = i, a = l.WeakMap, t = r(a) && /native code/.test(String(a));
export {
  t as w
};
